module.exports = __webpack_public_path__ + "assets/img/person_icon_e.f579eca5.png";